<template>
    <AppModal :title="$t('labels.create_document')" ref="modal">
        <div class="modal-body">
            <FormGroup :label="$t('labels.document_type')" :required="true">
                <Select
                    @update:model-value="newType => document.type = newType"
                    :model-value="document.type?.key"
                    :selected-value="document.type?.value"
                    :options="documentTypes"
                    option-key="key"
                    option-value="value"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.recipients_score')" v-if="document.type">
                <Select
                    @update:model-value="newBankDetail => document.projectBankDetail = newBankDetail"
                    :model-value="document.projectBankDetail?.key"
                    :selected-value="document.projectBankDetail?.value"
                    :options="projectBankDetailsOptions"
                    option-key="key"
                    option-value="value"
                    :can-be-empty="true"
                />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <AppButton size="sm" color="teal" @click="createDocument" :disabled="!document.type">
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Select from '../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import { DocumentTypeEnum } from '../../../../enums/DocumentTypeEnum';
import { httpClient } from '../../../../../services/HttpClient';
export default {
    name: 'CreateDocumentModal',
    components: {
        AppModal, FormGroup, Select, AppButton
    },
    props: {
        exitDeclaration: {
            type: Object,
            default: null
        }
    },
    emits: ['created'],
    data() {
        return {
            document: {
                type: null,
                projectBankDetail: null
            },
            projectBankDetails: []
        }
    },
    computed: {
        documentTypes() {
            return Object.values(DocumentTypeEnum).map((type) => ({
                key: type,
                value: this.$t(`enum.document.type.${type}`)
            }));
        },
        projectBankDetailsOptions() {
            return this.projectBankDetails.map((bankDetail) => ({
                key: bankDetail.uuid,
                value: bankDetail.name
            }));
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
        fetchBankDetails() {
            httpClient.get('/system/bank-details').then((response) => {
                this.projectBankDetails = response.data.data;
            });
        },
        createDocument() {
            let additional = {
                exit_declaration_uuid: this.exitDeclaration.uuid
            };

            if (this.document.projectBankDetail) {
                additional.project_bank_detail_uuid = this.document.projectBankDetail.key;
            }

            httpClient.post('/file/documents', {
                type: this.document.type.key,
                additional: additional,
                extra: 1
            }).then((response) => {
                let files = Object.entries(this.exitDeclaration.files ?? {}).map(([uuid, file]) => ({
                    document_uuid: uuid,
                    url: file.url
                }));

                files.push({
                    document_uuid: response.data.data.uuid,
                    url: response.data.data.file?.url ?? null
                });

                httpClient.patch(`/projects/${this.$route.params.projectUuid}/management/exit-declarations/${this.exitDeclaration.uuid}`, {
                    files: files
                }).then(() => {
                    this.$emit('created', {
                        uuid: response.data.data.uuid,
                        url: response.data.data.file?.url ?? null
                    });
                });

                this.hide();
                this.document = {
                    type: null,
                    projectBankDetail: null
                };
            });
        }
    },
    mounted() {
        this.fetchBankDetails();
    }
}
</script>
